import { render, staticRenderFns } from "./AscMxRecSupportInfoAttachmentsWrapper.vue?vue&type=template&id=7321ff7c&"
import script from "./AscMxRecSupportInfoAttachmentsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscMxRecSupportInfoAttachmentsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecSupportInfoAttachmentsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
